<script setup lang="ts"></script>

<template>
  <div class="not-found vacv-container-nopad">
    <h1>{{ $t("notFound.labels.title") }}</h1>
    <p>{{ $t("notFound.messages.description") }}</p>
  </div>
</template>
